import React from 'react';
import Icon from '../../../components/AppIcon';

const RenewalTimeline = () => {
  const renewals = [
    {
      id: 'T001',
      property: '123 High Street, London',
      tenant: 'John Smith',
      currentEnd: '28/02/2026',
      daysRemaining: 12,
      status: 'urgent',
    },
    {
      id: 'T002',
      property: '45 Park Avenue, Manchester',
      tenant: 'Sarah Johnson',
      currentEnd: '15/03/2026',
      daysRemaining: 27,
      status: 'upcoming',
    },
    {
      id: 'T003',
      property: '78 Queen Road, Birmingham',
      tenant: 'Michael Brown',
      currentEnd: '05/04/2026',
      daysRemaining: 48,
      status: 'normal',
    },
    {
      id: 'T004',
      property: '92 King Street, Leeds',
      tenant: 'Emma Wilson',
      currentEnd: '20/04/2026',
      daysRemaining: 63,
      status: 'normal',
    },
  ];

  const getStatusConfig = (status) => {
    switch (status) {
      case 'urgent':
        return {
          color: 'var(--color-error)',
          bg: 'rgba(230, 57, 70, 0.1)',
          icon: 'AlertCircle',
          label: 'Urgent',
        };
      case 'upcoming':
        return {
          color: 'var(--color-warning)',
          bg: 'rgba(244, 162, 97, 0.1)',
          icon: 'Clock',
          label: 'Upcoming',
        };
      default:
        return {
          color: 'var(--color-accent)',
          bg: 'rgba(45, 156, 219, 0.1)',
          icon: 'Calendar',
          label: 'Normal',
        };
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground font-heading">Tenancy Renewal Timeline</h3>
        <button className="text-sm text-accent hover:underline font-caption">
          View All
        </button>
      </div>
      <div className="space-y-3">
        {renewals?.map((renewal) => {
          const config = getStatusConfig(renewal?.status);
          return (
            <div 
              key={renewal?.id}
              className="p-4 rounded-lg border border-border transition-smooth hover:border-accent"
              style={{ backgroundColor: config?.bg }}
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-medium text-foreground font-data">{renewal?.id}</span>
                    <div 
                      className="px-2 py-0.5 rounded text-xs font-medium font-caption"
                      style={{ 
                        backgroundColor: config?.bg,
                        color: config?.color 
                      }}
                    >
                      {config?.label}
                    </div>
                  </div>
                  <p className="text-sm text-foreground mb-1">{renewal?.property}</p>
                  <p className="text-xs text-muted-foreground font-caption">Tenant: {renewal?.tenant}</p>
                </div>
                <Icon name={config?.icon} size={20} color={config?.color} />
              </div>
              <div className="flex items-center justify-between pt-3 border-t border-border">
                <div className="flex items-center gap-2">
                  <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
                  <span className="text-xs text-muted-foreground font-caption">Ends: {renewal?.currentEnd}</span>
                </div>
                <span 
                  className="text-sm font-medium font-data"
                  style={{ color: config?.color }}
                >
                  {renewal?.daysRemaining} days
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RenewalTimeline;